<it-checkbox [(ngModel)]="element.isAttivo" toggle="true" (click)="openConfirmModal($event)" [disabled]="!element.isAbilitabile || ente.isSolaLettura || isNotAttivabile(element)">
  <it-modal #confirmUtenteModal="itModal" closeButton="false" backdrop="static" keyboard="false">
    <ng-container modalTitle>Conferma {{ element.isAttivo ? 'disattivazione' : 'attivazione' }} utente</ng-container>
    <ng-container description>
      <p>Sei sicuro di voler {{ element.isAttivo ? 'disattivare' : 'attivare' }} l'utente <strong>{{element.codiceFiscale}}</strong>?</p>
    </ng-container>
    <ng-container footer>
      <button itButton="outline-primary" size="sm" type="button" (click)="closeModal()">Annulla</button>
      <button itButton="primary" size="sm" type="button" (click)="submit()">Conferma</button>
    </ng-container>
  </it-modal>
</it-checkbox>
